import Typography from '@mui/material/Typography';
import { useContext } from 'react';

import { Link } from '@ifa/ui/link';

import { EnvContext } from './AppLayout';

export default function Copyright() {
    const version = useContext(EnvContext).version;
    return (
        <>
            <Typography variant="body2" color="text.secondary" align="center">
                {`© ${new Date().getFullYear()} `}
                <Link color="inherit" target="_blank" rel="noopener" href="https://bethematch.org/">
                    National Marrow Donor Program. All rights reserved.
                </Link>
            </Typography>
            <Typography sx={{ display: 'none' }}>Current app version: {version}</Typography>
        </>
    );
}
